webpackJsonp([15400075347947],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createContactLink = exports.combineHeaders = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var combineHeaders = exports.combineHeaders = function combineHeaders() {
	  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.keys(searchParams).map(function (key) {
	    return key + '=' + encodeURIComponent(searchParams[key]);
	  }).join('&');
	};
	
	var createContactLink = exports.createContactLink = function createContactLink(tel, sms, facetime, email, headers) {
	  var link = void 0;
	  if (email) {
	    link = 'mailto:' + email;
	    if (headers) {
	      link += '?' + combineHeaders(headers);
	    }
	  } else if (tel) {
	    link = 'tel:' + tel;
	  } else if (sms) {
	    link = 'sms:' + sms;
	  } else if (facetime) {
	    link = 'facetime:' + facetime;
	  }
	  return link;
	};
	
	var Obfuscate = function (_Component) {
	  _inherits(Obfuscate, _Component);
	
	  function Obfuscate() {
	    _classCallCheck(this, Obfuscate);
	
	    return _possibleConstructorReturn(this, (Obfuscate.__proto__ || Object.getPrototypeOf(Obfuscate)).apply(this, arguments));
	  }
	
	  _createClass(Obfuscate, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props,
	          tel = _props.tel,
	          sms = _props.sms,
	          facetime = _props.facetime,
	          email = _props.email,
	          obfuscate = _props.obfuscate,
	          headers = _props.headers,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          href: createContactLink(tel, sms, facetime, email, headers)
	        }, others),
	        children || tel || sms || facetime || email
	      );
	    }
	  }, {
	    key: 'reverse',
	    value: function reverse(s) {
	      return s.split('').reverse().join('');
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _props2 = this.props,
	          tel = _props2.tel,
	          sms = _props2.sms,
	          facetime = _props2.facetime,
	          email = _props2.email,
	          obfuscate = _props2.obfuscate,
	          headers = _props2.headers,
	          children = _props2.children,
	          style = _props2.style,
	          others = _objectWithoutProperties(_props2, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children', 'style']);
	
	      var obsStyle = _extends({}, style || {}, {
	        unicodeBidi: 'bidi-override'
	      });
	
	      if (!children) {
	        obsStyle.direction = 'rtl';
	      }
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          onClick: this.handleClick.bind(this),
	          href: 'obfuscated'
	        }, others, {
	          style: obsStyle
	        }),
	        children || this.reverse(tel || sms || facetime || email).replace('(', ')').replace(')', '(')
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props,
	          tel = _props3.tel,
	          sms = _props3.sms,
	          facetime = _props3.facetime,
	          email = _props3.email,
	          headers = _props3.headers;
	
	      window.location.href = createContactLink(tel, sms, facetime, email, headers);
	    }
	  }]);
	
	  return Obfuscate;
	}(_react.Component);
	
	Obfuscate.propTypes = {
	  children: _propTypes.node,
	  tel: _propTypes.string,
	  sms: _propTypes.string,
	  facetime: _propTypes.string,
	  email: _propTypes.string,
	  headers: _propTypes.object,
	  obfuscate: _propTypes.bool,
	  style: _propTypes.object
	};
	
	Obfuscate.defaultProps = {
	  obfuscate: true
	};
	
	exports.default = Obfuscate;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactObfuscate = __webpack_require__(193);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _Page = __webpack_require__(45);
	
	var _Hero = __webpack_require__(29);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyPolicyPage = function PrivacyPolicyPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Page.BasicPage,
	    { heroImage: data.heroImage, name: 'privacyPolicy' },
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'ChouxBox Privacy Policy'
	      )
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Effective as of April 1, 2013'
	      )
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'CHOUXBOX INC. (collectively, \u201CCHOUXBOX\u201D, \u201Cwe\u201D, \u201Cus\u201D or \u201Cour\u201D) is committed to protecting the privacy of our users. Accordingly, we have developed this Privacy Policy (the \u201CPolicy\u201D) to inform users of our policies and procedures regarding the collection, use and disclosure of data we receive from visitors to the generally accessible web pages located at www.chouxbox.com (the \u201CSite\u201D) and our application for mobile devices (the \u201CApplication\u201D). Our primary goals in collecting information are to provide and improve our Site, Application, services, features, content, to administer your use of the Site and application (collectively, the \u201CService\u201D), and to enable users to enjoy and easily navigate the Site and Application. This Policy does not cover any other information that CHOUXBOX collects, including without limitation, information that CHOUXBOX collects offline or information it collects from registered users and customers about their businesses, employees or patrons via online accounts, applications, or password-restricted websites.'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'This Policy sets forth the policies and procedures of data and information, including but not limited to personally identifiable information, received from users of the Service. This Policy is applicable to all visitors of the Site and all users of the Application, and all other users, registered or otherwise, of the Service (collectively, \u201Cvisitors\u201D, \u201Cusers\u201D or \u201Cyou\u201D). By using the Service, you consent to your information being collected, disclosed and otherwise used as described in this Policy, which is incorporated by reference into the CHOUXBOX Terms of Service (the \u201CTerms\u201D). Unless otherwise defined in this Policy, terms used in this Policy have the same meanings as in our Terms, and capitalized terms used herein but not otherwise defined herein have the meanings given to them in the Terms. If you do not agree to the terms and conditions of this Policy, and the terms and conditions in our Terms, you are not authorized to use the Service. As used in this policy, the terms \u201Cusing\u201D and \u201Cprocessing\u201D information include using cookies on a computer, subjecting the information to statistical or other analysis and using or handling information in any way, including, but not limited to collecting, storing, evaluating, modifying, deleting, using, combining, disclosing and transferring information within our organization or among our affiliates within the United States or internationally.'
	    ),
	    _react2.default.createElement(
	      _Page.SubHeading,
	      null,
	      'Changes to the Privacy Policy'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'We may amend, update or change this Policy from time to time. Use of information we collect now is subject to the Policy in effect at the time such information is used. If we make changes to the Policy, we will post the revised Policy here. If we make material changes to the Policy, we will notify you by an e-mail sent to the address specified in your Account (defined below) or by means of a notice on the Site and Application once the change has become effective. You are encouraged to review the Policy from time to time in the event changes have been made. Your continued use of the Service indicates your assent to the Policy as posted and you agree that we may change it at any time, effective immediately.'
	    ),
	    _react2.default.createElement(
	      _Page.Heading,
	      null,
	      'INFORMATION WE COLLECT'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'We collect information to provide a better Service to all of our users. In some circumstances, certain users choose to interact with our Service in ways that require CHOUXBOX to gather personally identifiable information. In other circumstances, CHOUXBOX, like most website operators, will collect non-personally identifiable information. We use this information only insofar as is necessary or appropriate to fulfill the purpose of a visitor\u2019s interaction with the Service. When registering for an account with our Service (a \u201CCHOUXBOX Account\u201D), we receive and store personally identifiable information you enter or provide to us in any other way. The types address and zip code, and any other data that is tied to such information (collectively, the \u201CPersonal Information\u201D). We will not disclose Personal Information other than as described in this Policy. Of course, you can always refuse to provide Personal Information, but doing so may prevent you from using some or all of our Service. When you log in to an CHOUXBOX Account and interact with our Service, we may automatically collect and store information that has the potential to be personally identifiable, such as your Internet Protocol (IP address). We only use and disclose user IP addresses under the same circumstances that we use and disclose Personal Information under this Policy. When using a part of our Service, we may also collect, and you may also provide, non-personally identifiable information related to which part of our Service you are using and how you are using it, like when you view, interact with, or provide text, graphics, images, music, software (excluding the Application), audio, video, information, data and other materials (collectively \u201CContent\u201D). The amount and type of information that we gather depends on the nature of your interaction with our Service. Also, web browsers and servers typically make available certain non-personally identifiable information like system activity, hardware settings, browser type, browser language, date and time of a visitor\u2019s request and referral URL, and other technologies. This information may be stored on our server logs. We collect this information in order to better understand how our visitors interact with and use our Service, and to improve and carry out our Service.'
	    ),
	    _react2.default.createElement(
	      _Page.Heading,
	      null,
	      'HOW WE USE INFORMATION WE COLLECT'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'We use information we collect through the Service in order to provide, maintain, protect, and improve our Service, as well as to protect CHOUXBOX and our users and visitors. We also use this information to provide users with tailored Content. Personal Information about our users is an integral part of our business. We neither rent nor sell your Personal Information to anyone, except as described in this Policy. We use your Personal Information for such purposes as improving the content of the Service, customizing the Content you see, and communicating with you about specials and new features. We may also draw upon this Personal Information in order to adapt the Service and our community to your needs, to research the effectiveness of our network and Service, and to develop new tools for the community. We provide some of our services through affiliates, service providers, partners and other third parties. We, and our service partners, may use your personal information to operate our sites and to deliver their services. These affiliates and third party service providers are not permitted to use personal information for any purposes other than to assist you in participating in the particular service or promotional program, and communicating with you. We will encourage our service partners to adopt and post privacy policies. However, the use of your personal information by our service partners is governed by the privacy policies of those service partners, and is not subject to our control. We may share non-personally identifiable information publicly and with our partners and connected sites. We only use this data in aggregate for business and administrative purposes, and for the purposes of performing statistical analyses on user behavior and characteristics, and for improving the Service. By way of an example and not as a limitation, we may collect statistics about the behavior of visitors interacting with our Site, Application, and Service; we may monitor the most activities of our Service users; and/or we may display this information publicly or provide it to others, like through the publication of a report on usage trends of visitors. We may transfer Personal Information as an asset in connection with a proposed or actual merger or sale (including any transfers made as part of an insolvency or bankruptcy proceeding) involving all or part of our business or as part of a corporate reorganization, stock sale or other change in control. In such a circumstance the transferee would be bound by the terms of this Policy.'
	    ),
	    _react2.default.createElement(
	      _Page.SubHeading,
	      null,
	      'Feedback'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'We may use your e-mail address for Site and Application service updates and feedback solicitations. We use your feedback to improve our Service and our organization. If you choose to provide information about yourself using feedback, we will not use the information for any purpose other than to respond to your inquiry, act on your suggestion or comment, or collect statistical data on how our users interact with our Service and other services.'
	    ),
	    _react2.default.createElement(
	      _Page.Heading,
	      null,
	      'HOW YOUR PERSONAL INFORMATION IS PROTECTED'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'Your account is password protected for your privacy and security. You need to prevent unauthorized access to your account and Personal Information by selecting and protecting your password, and limiting access to your computer, phone and browser such as signing off after you have finished accessing your account. We are committed to protecting the information we receive from you, and we follow reasonable technical and management practices to help protect the confidentiality, security and integrity of Personal Information, potentially personally identifiable information, and data stored on our system. While no computer system is completely secure, we believe the measures we have implemented reduce the likelihood of security problems to a level appropriate to the type of data involved. The Service may contain links to other web sites. We are not responsible for the privacy policies and/or practices on other web sites. When linking to another web site, you should read the privacy policy stated on that web site. This Policy only governs information collected on the Service. We restrict access to Personal Information to CHOUXBOX employees, contractors and agents, or affiliated organizations who need to know this information in order to process it for us, and who are subject to confidentiality obligations. We review our information collection, storage and processing practices, including physical security measures, to guard against unauthorized access to systems. We employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Site-, Application-, and Service-related services (e.g., without limitation, maintenance services, database management, web analytics, and improvement of the Site, Application, and Service\u2019s features) or to assist us in analyzing how our Services are used. These third parties may have access to your Personal Information; if they do, this access is only so that they may perform these tasks on our behalf and they are obligated not to disclose or use if for any purpose.'
	    ),
	    _react2.default.createElement(
	      _Page.SubHeading,
	      null,
	      'Compliance with Law and Law Enforcement'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'CHOUXBOX cooperates with government and law enforcement officials and private parties to enforce and comply with the law. We may disclose your Personal Information to third parties in a good faith belief that such disclosure is reasonably necessary to (a) take action regarding suspected illegal activities; (b) enforce or apply our Terms and Privacy Policy; (c) comply with legal process, such as a search warrant, subpoena, statute, or court order; or (d) protect our rights, reputation, and property, or that of our users, affiliates, or the public. Please note that we are not required to question or contest the validity of any search warrant, subpoena or other similar governmental request that we receive.'
	    ),
	    _react2.default.createElement(
	      _Page.Heading,
	      null,
	      'THIRD PARTIES'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'The Service may contain links to third party web sites to which we have no affiliation. Except as otherwise discussed in this Policy, this document only addresses the use and disclosure of information we collect from you. Other web sites accessible through our web site via links or service partnerships have their own privacy policies and data collection, use and disclosure practices. Please consult each web site\u2019s privacy policy. We are not responsible for the policies or practices of third parties.'
	    ),
	    _react2.default.createElement(
	      _Page.Heading,
	      null,
	      'COOKIES AND SIMILAR TECHNOLOGIES'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'Like many websites and mobile applications, we use cookies and other means to collect information. A cookie is a small data file that we transfer to your computer\u2019s hard disk for record-keeping purposes. We send cookies to your computer through your browser to enable our systems to recognize your browser and tell us how and when pages in our web site are visited and by how many people. Most browsers have an option for disabling the cookie feature, which will prevent your browser from accepting cookies or will enable your browser to notify you when one is being placed. However, cookies are necessary to access the web site. We use analytics (and related analytics programs) to better understand who is using the Service, and how people are using it. Analytics uses cookies to collect and store anonymous information such as time of visit, pages visited, time spent on each page of the web site, IP address, and type of operating system used. We use this information to improve the Service and make it appealing to as many users as possible. Our Site, Application, and Service may contain electronic images known as web beacons (sometimes called single-pixel gifs) and are used along with cookies to compile aggregated statistics to analyze how our Service is used and may be used in some of our emails to let us know which emails and links have been opened by recipients. This allows us to gauge the effectiveness of our customer communications and marketing campaigns.'
	    ),
	    _react2.default.createElement(
	      _Page.Heading,
	      null,
	      'MISCELLANEOUS'
	    ),
	    _react2.default.createElement(
	      _Page.SubHeading,
	      null,
	      'International Transfer'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'YOUR INFORMATION MAY BE TRANSFERRED TO \u2013 AND MAINTAINED ON \u2013 COMPUTERS LOCATED OUTSIDE OF YOUR STATE, PROVINCE, COUNTRY OR OTHER GOVERNMENTAL JURISDICTIONS WHERE THE PRIVACY LAWS MAY NOT BE AS PROTECTIVE AS THOSE IN YOUR JURISDICTION. IF YOU ARE LOCATED OUTSIDE THE UNITED STATES AND CHOOSE TO PROVIDE INFORMATION TO US, CHOUXBOX TRANSFERS PERSONAL INFORMATION TO THE UNITED STATES AND PROCESSES IT THERE. YOUR CONSENT TO THIS PRIVACY POLICY FOLLOWED BY YOUR SUBMISSION OF SUCH INFORMATION REPRESENTS YOUR AGREEMENT TO THAT TRANSFER.'
	    ),
	    _react2.default.createElement(
	      _Page.SubHeading,
	      null,
	      'Our Privacy Toward Children'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'The Service is not directed to individuals under 18. We do not knowingly collect personally identifiable information from children under 13. If a parent or guardian becomes aware that his or her child has provided us with Personal Information without their consent, he or she should contact us. If we become aware that a child under 13 has provided us with Personal Information, we will delete such information from our files.'
	    ),
	    _react2.default.createElement(
	      _Page.SubHeading,
	      null,
	      'Contacting Us'
	    ),
	    _react2.default.createElement(
	      _Page.Paragraph,
	      null,
	      'All comments, queries and requests relating to our use of your information are welcomed and should be addressed to ',
	      _react2.default.createElement(_reactObfuscate2.default, { email: 'info@chouxbox.com' }),
	      '.'
	    )
	  );
	};
	
	exports.default = PrivacyPolicyPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-a1bfbb0e3a9d8c25a79d.js